module.exports = __webpack_public_path__ + "static/media/spotify.7a34cf42.png";